import { types } from 'mobx-state-tree'

export const MeetUserStore = types.model({
    status: types.maybeNull(types.string),
})
